

<div class="mat-elevation-z8">
<table mat-table [dataSource]="dataSource" matSort>

  <!-- Your existing columns -->
  <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
    
   
    @if (col === 'button_update'){
    <th  mat-header-cell *matHeaderCellDef >Update</th>
    } @else if (col === 'button_delete'){
    <th  mat-header-cell *matHeaderCellDef >Delete</th>
    } @else {
<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ columns[col].title }}</th>
    
    }


    @if  (col === 'button_update'){
    <td mat-cell *matCellDef="let row">
    <button mat-icon-button color="warn" (click)="onUpdate(row)">
      update
    </button>
    </td>
  } @else if (col === 'button_delete'){
    <td mat-cell *matCellDef="let row">
    <button mat-icon-button color="warn" (click)="onDelete(row)">
      delete
    </button>
    </td>
    } @else {
        
          <td mat-cell *matCellDef="let row">
            @if  (getLink(row, columns[col],columns ) === undefined ){
              {{ getByPath(row, columns[col].store_key)}}
            } @else {
              <a [href]="getLink(row, columns[col],columns )">{{ getByPath(row, columns[col].store_key)}}</a>
            }
          </td>
        
    }
  
  </ng-container>

  <!-- Header & rows -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row        *matRowDef="let row; columns: displayedColumns"></tr>

</table>

  <mat-paginator
    [length]="resultsLength"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    aria-label="Select page">
  </mat-paginator>
</div>

